import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withModifiers as _withModifiers, withKeys as _withKeys, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-03e73260")

_pushScopeId("data-v-03e73260")
const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa = _resolveComponent("fa")

  return (_ctx.isShow)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: "dialog",
        onClick: _cache[4] || (_cache[4] = ($event: any) => {if (_ctx.isHideClose || !_ctx.title) _ctx.close();}),
        onKeydown: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["esc"])),
        tabindex: "1",
        ref: "input"
      }, [
        _createVNode("div", {
          class: ["box", { 'fit-box': _ctx.isFitSize }],
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dummy && _ctx.dummy(...args)), ["stop"]))
        }, [
          (_ctx.title !== undefined)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                (!_ctx.isHideBack)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      class: ["back", { isLeft: _ctx.isLeftTitle, isRight: _ctx.isRightTitle }],
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
                    }, [
                      _createVNode(_component_fa, { icon: ['fas', 'arrow-left'] })
                    ], 2))
                  : _createCommentVNode("", true),
                _createVNode("p", {
                  class: { isLeft: _ctx.isLeftTitle, isRight: _ctx.isRightTitle }
                }, _toDisplayString(_ctx.title), 3),
                (!_ctx.isHideClose)
                  ? (_openBlock(), _createBlock("button", {
                      key: 1,
                      class: ["close", { isLeft: _ctx.isLeftTitle, isRight: _ctx.isRightTitle }],
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                    }, [
                      _createVNode(_component_fa, { icon: ['fas', 'times'] })
                    ], 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ], 2)
      ], 544))
    : _createCommentVNode("", true)
})